module.exports = __webpack_public_path__ + "img/Guatemala.5f5240a2.svg";